module.exports = __webpack_public_path__ + "static/media/R-Smart MotorS-en.623002a2.jpg";